// モジュール名
export const moduleName = 'play'

export const Getter = {
  AUDIO_CONTEXT: 'audio_context',
  SOUND_SOURCES: 'soundSources',  // 全音素材のリスト
  SOUND_SOURCE: 'soundSource',  // IDに該当する音
  HAS_PLAYING_BUFFER_SOURCE: 'hasPlayingBufferSource',
}

export const Mutation = {
  AUDIO_CONTEXT: {
    CREATE: 'audioContext.create',
    STOP: 'audioContext.stop',
    START_AT: 'audioContext.startAt',
  },
  SCORE: {
    ADD_SOUND: 'score.addSound',
    UNDO: 'score.undo',
    RESET: 'score.reset',
  },
  TRACK_WIDTH_PER_SECOND: {
    SM: 'trackWidthPerSecondToSmall',
    MD: 'trackWidthPerSecondToMedium',
  },  // 1秒あたりのトラックの幅を変更する
  CHANGE_PLAY_MODE: 'changePlayMode',  // 再生モードを設定
  CHANGE_ACTIVE_TRACK: 'changeActiveTrack', // トラックを変更する
  SET_AUDIO_BUFFER: 'setAudioBuffer',
  PLAYING_BUFFER_SOURCE: {
    ADD: 'playingBufferSource.add',  // 再生されたソースをリストに追加する
    REMOVE: 'playingBufferSource.remove',  // ソースをリストから削除
    CLEAR: 'playingBufferSource.clear',  // クリア
  },
  COUNTDOWN: {
    START: 'countdown.start',
    STOP: 'countdown.stop',
  },
  CHANGE_PLAY_STATUS: 'changePlayStatus', // 再生・停止のステータス管理
  AUDIO_LATENCY_ADJUST: 'audioLatencyAdjust', // 音ずれの調整
  USER_SOUND: {
    SET: 'userSound.set',
    // REMOVE: 'userSound.remove',
  },  // ユーザーが録音した音
  DEBUG: {
    SCORE: {
      RESTORE: 'debug.score.restore', // デバッグ用 クエリーからスコアを復元する
    },
  },  // デバッグ用
}

export const Action = {
  FETCH_AUDIO_FILE: 'fetchAudioFile', // 音をXHRで取得する
}

// 音ID
export type SoundId =
  'bgm'
  | 'train1'
  | 'train2'
  | 'train-door'
  | 'call-for-departure'
  | 'soon-ebina'
  | 'crossing'
  | 'guitar'
  | 'bass'
  | 'drum'
  | 'piano'
  | 'train-running'
  | 'maracas'
  | 'dog'
  | 'cat'
  | 'dj'
  | 'robot'
  | 'user-recorded' // ユーザー録音

// トラック番号
export type TrackIndex = 0 | 1

// スコアに配置された音
export interface SoundOnScore {
  id: number;
  soundId: SoundId;  // 音ID
  trackIndex: TrackIndex;  // 配置されたトラックのインデックス
  when: number; // 再生タイミング
}

// 音
// TODO キーの情報も含んでしまっているので、型を分割すべきかもしれない
export interface SoundSrc {
  soundId: SoundId;
  label: string;
  src?: string;
  icon?: string;  // アイコン画像
  keyImage?: string;  // キーに表示される画像
  color?: string; // 色
  beatLength?: number;  // 拍数
  audioBuffer?: AudioBuffer;
}

// ユーザーの録音した音
export interface UserRecordedSoundSrc extends SoundSrc {
  hasAudioBuffer: boolean;
}

// // BGM
// export interface BgmSrc {
//   soundId: SoundId;
//   label: string;
//   src?: string;
//   audioBuffer?: AudioBuffer;
// }

// エフェクトのショートカットキー
export interface EffectShortcutKey {
  label: string;
  code: string;
}

// 再生中の音
export interface PlayingBufferSource {
  id: number; // 再生リストのID
  soundId: SoundId;  // 音ID
  audioBufferSourceNode: AudioBufferSourceNode;
}

export interface PlayingBufferSourcePayload {
  id: number;
  soundId: SoundId;
  node: AudioBufferSourceNode;
}

// 再生モード（収録、再生）
export type PlayMode = 'record' | 'play';

export interface State {
  audioContext: AudioContext | null;
  audioContextStartAt: number;  // 再生時に進んでいたAudioContextの時間
  score: SoundOnScore[]; // 楽譜（みたいなもの）
  removedScore: SoundOnScore[]; // 削除された音
  playingBufferSources: PlayingBufferSource[]; // 再生中の音一覧（再生履歴ではない）
  soundSources: {
    bgm: SoundSrc[];  // BGMの一覧
    effect: SoundSrc[];  // 効果音の一覧
    userRecorded: UserRecordedSoundSrc; // ユーザーが録音した音
  };
  duration: number; // BGMの再生時間
  barDuration: number;  // 1小節の秒数
  trackWidthPerSecond: number;  // 1秒あたりのトラックの幅
  audioLatencyAdjust: number; // 遅れを調整
  playMode: PlayMode;  // 再生モード
  isRecordMode: boolean;  // 録音モード
  isPlaying: boolean; // 再生中（収録中含む）か
  isCountingDown: boolean;  // 収録前のカウントダウン中か
  isReady: boolean; // 準備できたか（音をすべてAudioBufferに変換したか）
  currentTime: number;  // 再生中の時間
  selectedTrackIndex: TrackIndex; // 選択中のトラックインデックス
}
